import React, { useEffect } from 'react';
import styled from 'styled-components';
import { formatNumber } from '@debbie/common/dist';
import { moneyCalculatorKey, useMoneyCalculator, } from '@debbie/cortex/dist/moneyCalculator';
import THEME from '../theme';
import { h } from '@debbie/cortex/dist';
import q from '@debbie/cortex/dist/query';
const MoneyCalculator = () => {
    const loadable = useMoneyCalculator();
    const { count, items, sum } = h.hasData(loadable)
        ? loadable.data
        : { sum: 0, count: 0, items: {} };
    return count !== 0 ? React.createElement(Panel, null) : null;
};
const Panel = () => {
    const loadable = useMoneyCalculator();
    const { sum, count, items } = h.hasData(loadable)
        ? loadable.data
        : { sum: 0, count: 0, items: {} };
    const deactivateAll = () => {
        q.mutateCache(moneyCalculatorKey, (current) => {
            if (!current) {
                return current;
            }
            current.items = {};
            current.count = 0;
            current.sum = 0;
            return current;
        });
    };
    useEffect(() => {
        const eventListener = (e) => {
            if (e.keyCode === 27) {
                deactivateAll();
            }
        };
        document.addEventListener('keydown', eventListener);
        return () => {
            document.removeEventListener('keydown', eventListener);
        };
    }, []);
    return (React.createElement(StyledCalculator, null,
        React.createElement("small", { style: { color: 'grey' } }, "Sum "),
        React.createElement("span", { style: { fontSize: '1.6em', fontWeight: 'bold' } }, formatNumber(sum)),
        React.createElement("div", { style: { marginTop: '5px', fontSize: '0.8em', textAlign: 'right' } },
            React.createElement("span", { style: { color: 'grey' } }, "Avg. "),
            React.createElement("strong", null,
                formatNumber(sum / count),
                " "),
            React.createElement("span", { style: { color: 'grey' } }, "count "),
            React.createElement("strong", null, count))));
};
export default MoneyCalculator;
const StyledCalculator = styled.div `
  position: fixed;
  bottom: 265px;
  right: ${THEME.GRID_SPACING}px;
  padding: ${THEME.GRID_SPACING}px;
  background-color: ${THEME.COLOR_SECONDARY};
  box-shadow: 0 20px 70px -30px black;
`;
//# sourceMappingURL=MoneyCalculator.js.map